import classNames from 'classnames'
import React from 'react'
import './form-action.scss'

type Props = {
  position?: 'left' | 'right' | 'center'
  children?: any;
  className?: string;
}

export const FormAction = ({ position = 'center', className, children }: Props) => {
  return (
    <div className={classNames('form-action-component mt-10', className, {
      'form-action-component--left': position === 'left',
      'form-action-component--right': position === 'right',
    })}>{ children }</div>
  )
}
